/** Phoenix PH2004 exports HTML-only templates with a dummy text/plain part. */
export function isPhoenixPlaceholderPlainText(text: string | null | undefined): boolean {
  if (!text?.trim()) return false;
  const normalized = text.trim().replace(/\s+/g, ' ').toLowerCase();
  return (
    (normalized.includes('does not contain') || normalized.includes('does not contains')) &&
    normalized.includes('text information')
  );
}

export function effectivePlainTextBody(text: string | null | undefined): string | null {
  if (!text?.trim() || isPhoenixPlaceholderPlainText(text)) return null;
  return text;
}
